import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { CuiToastOutletComponent } from '@idealink-material/ui-core';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, CuiToastOutletComponent],
  template: `
    <router-outlet />
    <p-toast-outlet />
  `
})
export class App {}
